import React from "react";

function SideBar() {
  return (
    <aside className="sidebar">
      <a
        href="/account/mywallet"
        className="item is-active"
        data-router-set=""
      >
        <span className="icon guy-mini">
          <svg
            width="12"
            height="15"
            viewBox="0 0 12 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.5 0.25C3.63333 0.25 2 1.88333 2 3.75C2 5.61667 3.63333 7.25 5.5 7.25C7.36667 7.25 9 5.61667 9 3.75C9 1.88333 7.36667 0.25 5.5 0.25Z"
              fill="white"
            ></path>
            <path
              d="M0.7 11.15L0 14.75H11.5L10.6 11.05C10.4 9.75 9.2 8.75 7.8 8.75H3.7C2.3 8.75 1 9.75 0.7 11.15Z"
              fill="white"
            ></path>
          </svg>
        </span>
        <span className="text">Ví của bạn</span>
      </a>
     
      {/* <a
        href="/account/orders"
        className="item "
        data-router-set=""
      >
        <span className="icon lock">
          <svg
            id="Calque_1"
            data-name="Calque 1"
            xmlns="http://www.w3.org/2000/svg"
            width="139"
            height="166.92"
            viewBox="0 0 139 166.92"
          >
            <title>lock</title>
            <path d="M128,74.92V59A59,59,0,0,0,10,59V74.92H0v92H139v-92ZM37,59a32,32,0,0,1,64,0V74.92H37Z"></path>
          </svg>
        </span>
        <span className="text">Đơn hàng</span>
      </a> */}
      <a
        href="/account/courses"
        className="item"
        data-router-set=""
      >
        <span className="icon guy-mini">
          <svg
            width="12"
            height="15"
            viewBox="0 0 12 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.5 0.25C3.63333 0.25 2 1.88333 2 3.75C2 5.61667 3.63333 7.25 5.5 7.25C7.36667 7.25 9 5.61667 9 3.75C9 1.88333 7.36667 0.25 5.5 0.25Z"
              fill="white"
            ></path>
            <path
              d="M0.7 11.15L0 14.75H11.5L10.6 11.05C10.4 9.75 9.2 8.75 7.8 8.75H3.7C2.3 8.75 1 9.75 0.7 11.15Z"
              fill="white"
            ></path>
          </svg>
        </span>
        <span className="text">Khóa học đã mua</span>
      </a>

      <a
        href="/account/settings"
        className="item "
        data-router-set=""
      >
        <span className="icon gear">
          <svg
            width="17"
            height="18"
            viewBox="0 0 17 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.9529 5.85818C17.0656 6.1641 16.9705 6.50518 16.7274 6.72319L15.2021 8.10862C15.2408 8.40047 15.2619 8.69936 15.2619 9.00176C15.2619 9.30416 15.2408 9.60305 15.2021 9.8949L16.7274 11.2803C16.9705 11.4983 17.0656 11.8394 16.9529 12.1453C16.7979 12.5638 16.6112 12.9646 16.3963 13.3514L16.2307 13.6363C15.9982 14.0231 15.7375 14.3887 15.4522 14.7333C15.2443 14.9865 14.8991 15.0709 14.5891 14.9725L12.6269 14.3501C12.1549 14.7122 11.6335 15.0147 11.0769 15.2432L10.6366 17.251C10.5661 17.571 10.3195 17.8242 9.99541 17.8769C9.50927 17.9578 9.00904 18 8.49824 18C7.98744 18 7.48721 17.9578 7.00106 17.8769C6.67697 17.8242 6.43038 17.571 6.35992 17.251L5.91957 15.2432C5.36298 15.0147 4.84161 14.7122 4.36956 14.3501L2.4109 14.976C2.1009 15.0744 1.75567 14.9865 1.54782 14.7369C1.26248 14.3923 1.0018 14.0266 0.769293 13.6398L0.603723 13.355C0.388834 12.9682 0.202128 12.5673 0.047126 12.1489C-0.0656024 11.8429 0.0295122 11.5019 0.272583 11.2838L1.79794 9.89842C1.75919 9.60305 1.73805 9.30416 1.73805 9.00176C1.73805 8.69936 1.75919 8.40047 1.79794 8.10862L0.272583 6.72319C0.0295122 6.50518 -0.0656024 6.1641 0.047126 5.85818C0.202128 5.43973 0.388834 5.03888 0.603723 4.65208L0.769293 4.36726C1.0018 3.98047 1.26248 3.61477 1.54782 3.27017C1.75567 3.017 2.1009 2.9326 2.4109 3.03106L4.37308 3.65345C4.84513 3.29127 5.3665 2.98887 5.9231 2.7603L6.36344 0.752491C6.4339 0.432506 6.68049 0.179332 7.00459 0.126587C7.49073 0.0421957 7.99096 0 8.50176 0C9.01256 0 9.5128 0.0421957 9.99894 0.123071C10.323 0.175816 10.5696 0.42899 10.6401 0.748974L11.0804 2.75679C11.637 2.98535 12.1584 3.28775 12.6304 3.64993L14.5926 3.02754C14.9026 2.92909 15.2479 3.017 15.4557 3.26665C15.741 3.61125 16.0017 3.97695 16.2342 4.36374L16.3998 4.64856C16.6147 5.03536 16.8014 5.43622 16.9564 5.85466L16.9529 5.85818ZM8.50176 11.8148C9.2492 11.8148 9.96602 11.5184 10.4945 10.9909C11.0231 10.4633 11.32 9.74783 11.32 9.00176C11.32 8.25569 11.0231 7.54018 10.4945 7.01263C9.96602 6.48508 9.2492 6.18871 8.50176 6.18871C7.75433 6.18871 7.0375 6.48508 6.50898 7.01263C5.98047 7.54018 5.68355 8.25569 5.68355 9.00176C5.68355 9.74783 5.98047 10.4633 6.50898 10.9909C7.0375 11.5184 7.75433 11.8148 8.50176 11.8148Z"
              fill="white"
            ></path>
          </svg>
        </span>
        <span className="text">Cài đặt</span>
      </a>

    </aside>
  );
}

export default SideBar;
